import * as Yup from 'yup';

Yup.addMethod(Yup.string, 'maxCounter', function (max) {
	return this.test(
		'maxCounter',
		'checking value length for exceeding max',
		function (value) {
			const { path, createError } = this;
			return (
				!!!value ||
				(!!value && value.length <= max) ||
				createError({
					path,
					message: `The value provided has exceeded the maximum:  ${value.length} / ${max} characters.`,
				})
			);
		}
	);
});
Yup.addMethod(Yup.string, 'minCounter', function (min) {
	return this.test(
		'minCounter',
		'checking value length for less than min',
		function (value) {
			const { path, createError } = this;
			return (
				!!!value ||
				(!!value && value.length >= min) ||
				createError({
					path,
					message: `The value provided has too few characters:  ${value.length} / ${min} characters.`,
				})
			);
		}
	);
});

Yup.addMethod(Yup.string, 'isAlphaNumeric', function () {
	return this.test(
		'isAlphaNumeric',
		'checking for invalid characters',
		function (value) {
			if (value) {
				const { path, createError } = this;
				const invalidStrings = ['/*', '*/', 'xp_', "'"];
				const regex = /^[0-9a-zA-Z]*$/;
				if (
					invalidStrings.some(x => value.includes(x)) ||
					!value.match(regex)
				) {
					return createError({
						path,
						message: `The value provided contains invalid characters`,
					});
				}
			}
			return true;
		}
	);
});

export default Yup;
